import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { withStyles } from '@material-ui/core/styles'
import Icon from '@material-ui/core/Icon'
import LaunchIcon from '@material-ui/icons/Launch'
import Drawer from '@material-ui/core/Drawer'
import { signOut } from 'redux/modules/auth'
import Logo from 'assets/logo.png'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import List from '@material-ui/core/List'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import MenuIcon from '@material-ui/icons/Menu'
import Button from '@material-ui/core/Button'
import Avatar from '@material-ui/core/Avatar'
import Divider from '@material-ui/core/Divider'
import Grid from '@material-ui/core/Grid'
import Hidden from '@material-ui/core/Hidden'
import amber from '@material-ui/core/colors/amber'
const propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  signOut: PropTypes.func.isRequired
}
const styles = theme => ({
  root: {
    flexGrow: 1
  },
  flex: {
    flex: 1
  },
  logoAvatar: {
    margin: 20,
    width: 64,
    height: 64
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20
  },
  buttonRight: {
    margin: 6
  },
  rightIcon: {
    marginLeft: theme.spacing.unit
  },
  list: {
    width: 250
  },
  listItemSelected: {
    borderRight: `2px solid ${theme.palette.primary.main}`,
    backgroundColor: 'rgba(0,0,0,0.14)'
  },
  sizeSmall: {
    minWidth: 0,
    width: 46,
    height: 46
  },
  appBar: {
    backgroundColor: __DEV__ || __STAGING__ ? amber[500] : ''
  }
})
const adminPath = '/admin'
const menu = [
  {
    index: 0,
    label: 'Dashboard',
    iconName: 'dashboard',
    route: '/'
  },
  {
    index: 1,
    label: 'Tables',
    iconName: 'settings_overscan',
    route: '/tables'
  },
  {
    index: 2,
    label: 'Tarifs',
    iconName: 'euro_symbol',
    route: '/pricings'
  },
  {
    index: 3,
    label: 'Joueurs',
    iconName: 'face',
    route: '/players'
  },
  {
    index: 4,
    label: 'Catégories',
    iconName: 'local_offer',
    route: '/categories'
  },
  {
    index: 5,
    label: 'Produits',
    iconName: 'local_bar',
    route: '/products'
  },
  {
    index: 6,
    label: 'Clients',
    iconName: 'people',
    route: '/customers'
  },
  {
    index: 7,
    label: 'Casiers',
    iconName: 'lock',
    route: '/lockers'
  },
  {
    index: 8,
    label: 'Utilisateurs',
    iconName: 'supervisor_account',
    route: '/users'
  },
  {
    index: 9,
    label: 'Préferences',
    iconName: 'settings',
    route: '/settings'
  }
]

class AdminHeaderContainer extends Component {
  state = {
    left: false,
    currentIndex: 0
  }

  initIndex(props) {
    menu.map(item => {
      if (props.location.pathname.startsWith(adminPath + item.route)) {
        this.setState({ currentIndex: item.index })
      }
      return item
    })
  }
  componentWillMount() {
    this.initIndex(this.props)
  }

  toggleDrawer = (side, open) => () => {
    this.setState({
      [side]: open
    })
  }
  handleClickLeftIconButton = () => {
    this.setState({
      left: !this.state.left
    })
  }
  handleChangeRequestNavDrawer = open => {
    this.setState({
      openDrawer: false
    })
  }
  handleClickHeader = event => {
    this.goToDashpool()
  }
  onRightButtonClick = e => {
    this.goToDashpool()
  }
  goToDashpool = () => {
    this.props.history.replace('/home')
  }
  handleChange = value => e => {
    if (value === 'logout') {
      this.props.signOut()
      return
    }
    this.props.history.replace(value)
    this.setState({ left: false })
  }
  componentWillReceiveProps(nextProps) {
    this.initIndex(nextProps)
  }

  render() {
    const { classes } = this.props
    return (
      <div>
        <AppBar className={classes.appBar} elevation={5} position="static">
          <Toolbar>
            <IconButton
              className={classes.menuButton}
              onClick={this.handleClickLeftIconButton}
              color="inherit"
              aria-label="Menu">
              <MenuIcon color="inherit" />
            </IconButton>
            <Typography
              variant="title"
              color="inherit"
              className={classes.flex}>
              {menu[this.state.currentIndex].label}
            </Typography>
            <Hidden smDown>
              <Button
                color="secondary"
                variant="raised"
                size="small"
                onClick={this.onRightButtonClick}
                style={styles.buttonRight}>
                Aller sur Dashpool
                <LaunchIcon color="inherit" className={classes.rightIcon} />
              </Button>
            </Hidden>
            <Hidden mdUp>
              <Button
                classes={{ sizeSmall: classes.sizeSmall }}
                color="secondary"
                variant="fab"
                size="small"
                onClick={this.onRightButtonClick}>
                <LaunchIcon color="inherit" />
              </Button>
            </Hidden>
          </Toolbar>
        </AppBar>
        <Drawer
          open={this.state.left}
          onClose={this.toggleDrawer('left', false)}>
          <div
            tabIndex={0}
            role="button"
            onClick={this.toggleDrawer('left', false)}
            onKeyDown={this.toggleDrawer('left', false)}>
            <Grid
              className={classes.list}
              container
              justify="center"
              alignItems="center">
              <Avatar className={classes.logoAvatar} src={Logo} />
            </Grid>
            <Divider />
            <List className={classes.list}>
              {menu.map(item => {
                const fontIcon = (
                  <Icon className="material-icons" color="primary">
                    {item.iconName}
                  </Icon>
                )
                return (
                  <ListItem
                    divider
                    key={item.index}
                    button
                    className={
                      item.index === this.state.currentIndex
                        ? classes.listItemSelected
                        : ''
                    }
                    onClick={this.handleChange(adminPath + item.route)}>
                    <ListItemIcon>{fontIcon}</ListItemIcon>
                    <ListItemText primary={item.label} />
                  </ListItem>
                )
              })}
              <ListItem button onClick={this.handleChange('logout')}>
                <ListItemIcon>
                  <Icon className="material-icons" color="secondary">
                    power_settings_new
                  </Icon>
                </ListItemIcon>
                <ListItemText primary="Déconnexion" />
              </ListItem>
            </List>
          </div>
        </Drawer>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {}
}
const mapActionCreators = {
  signOut
}

AdminHeaderContainer.propTypes = propTypes
export default withRouter(
  connect(mapStateToProps, mapActionCreators)(
    withStyles(styles)(AdminHeaderContainer)
  )
)



// WEBPACK FOOTER //
// ./src/containers/AdminHeaderContainer.js